import { render, staticRenderFns } from "./resourceVariableDialog.vue?vue&type=template&id=7b585027"
import script from "./resourceVariableDialog.vue?vue&type=script&lang=js"
export * from "./resourceVariableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports